// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';
import type { NeedsObjectivesSectionContent } from '../../../types/proposal';

interface Props {
  readonly content: NeedsObjectivesSectionContent;
}

/** NEEDS_OBJECTIVES — bullet list + optional narrative paragraph (read-only). */
const PlanNeedsObjectivesSection: React.FC<Props> = ({ content }) => {
  const bullets = content.bullets ?? [];
  return (
    <div data-testid="plan-needs-objectives">
      {bullets.length > 0 && (
        <ul className="proposal-plan__bullets" data-testid="plan-needs-bullets">
          {bullets.map((bullet, i) => (
            <li key={i}>{bullet}</li>
          ))}
        </ul>
      )}
      {content.narrative && (
        <p className="proposal-plan__narrative" data-testid="plan-needs-narrative">
          {content.narrative}
        </p>
      )}
    </div>
  );
};

export default PlanNeedsObjectivesSection;
